import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from './translation/en.json';
import translationDE from './translation/de.json';
import appConfig from '../../app.config';

export const supportedLngs = [
    { key: "en", name: "English" },
    { key: "de", name: "Deutsch" },
  ];

const resources = {
    en: {
        translation: translationEN
    },
    de: {
        translation: translationDE
    }
};

i18next.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        debug: appConfig.env == 'development',
        fallbackLng: "en",
        resources,
        supportedLngs: supportedLngs.map(language => language.key),
    });

export default i18next;